/****   http.js   ****/
// 导入封装好的axios实例
import { head } from 'lodash';
import request from './request'

// 开发环境和生产环境走代理
// 不然走线商接口
let baseURL = process.env.NODE_ENV === "development" ? '' : "";
console.log(baseURL, 'baseURL')

const http = {
    /**
     * methods: 请求
     * @param url 请求地址 
     * @param params 请求参数
     */
    get(url, params, headers) {
        const config = {
            method: 'get',
            url: baseURL + url
        }
        if (params) config.params = params
        if (headers) config.headers = headers
        return request(config)
    },
    post(url, params, headers, urls) {
        urls = urls ? urls : baseURL
        const config = {
            method: 'post',
            url: urls + url
        }
        //console.log(url)
        if (params) config.data = params
        if (headers) config.headers = headers

        return request(config)
    },
    put(url, params) {
        const config = {
            method: 'put',
            url: baseURL + url
        }
        if (params) config.params = params
        return request(config)
    },
    daily(url, params) {
        const config = {
            method: 'post',
            url: baseURL + url,
            responseType: "blob",
        }
        if (params) config.data = params
        return request(config)
    },
    delete(url, params) {
        const config = {
            method: 'delete',
            url: baseURL + url
        }
        if (params) config.params = params
        return request(config)
    }
}
//导出
export default http